import { Component, Prop, Vue } from 'vue-property-decorator'
import RatingStars from '~/components/element/RatingStars'
import Btn from '~/components/element/Btn'
import s from '~/utils/s'
import Review from '~/types/api/Review'
import Rating from '~/types/api/Rating'

@Component
export default class ReviewsSidebar extends Vue {
  @Prop({ type: Object, required: true })
  readonly rating?: Rating

  @Prop({ type: Object })
  readonly userReview?: Review

  showReviewPopup (event: MouseEvent) {
    event.stopPropagation()

    s(this.$store).reviewsPage.showPopup()
  }

  renderRatingsList() {
    const maxRating = RatingStars.maxValue
    const { reviews: { byRating } } = s(this.$store).productPage.rating

    return (
      <div class="reviews-sidebar__list-ratings">
        <span>Отзывы с оценкой</span>

        <ul>
          { [...Array(maxRating)].map((v, i) =>
            <li>
              <RatingStars {...{
                props: {
                  rating: i + 1,
                  reviewsCount: byRating[i]
                }
              }} />
            </li>
          ) }
        </ul>
      </div>
    )
  }

  render () {
    const rating = this.rating?.value || 0
    const reviewsCount = this.rating?.reviews?.total || 0
    const maxRating = RatingStars.maxValue

    return (
      <div class="reviews-sidebar">
        <div class="reviews-sidebar__body">
          <div class="reviews-sidebar__rating-wrapper">
            <div class="reviews-sidebar__rating">
              <div>
                { Number.isInteger(rating) ? rating : rating.toFixed(2) }
                <span class="reviews-sidebar__rating_of">
                  { maxRating }
                </span>
              </div>

              <RatingStars {...{
                props: {
                  rating, reviewsCount
                }
              }} />
            </div>
            { }
          </div>

          { this.renderRatingsList() }
        </div>

        <div class="reviews-sidebar__footer">
          <Btn {...{
            props: {
              label: this.userReview?.id ? 'Изменить свой отзыв' : 'Оставить отзыв',
              type: 'button',
              wide: true
            },
            nativeOn: {
              click: this.showReviewPopup
            }
          }} />
        </div>
      </div>
    )
  }
}
